export default __webpack_public_path__ + "static/logo-d16e5ac9ba435dc0e1ebd6a15356e1b6.png";